export default {
    name: "b4-login-menu",
    data: function () {
        return {
            menu: false,
        };
    }
};
